<!-- 底部合规说明：风险披露及免责声明 -->
<script lang="ts">
  import { _ as t } from "svelte-i18n";
</script>

<section class="risk">
  <p>{$t("risk_title")}</p>
  <p class="risk-content mt-[4px]">{$t("risk_content")}</p>
</section>

<style>
  /* 字号/字重设计稿未标注，按稿子目测：12px / 400 / 150% / #FFFFFF，正文两端对齐 */
  .risk {
    font-size: 12px;
    font-weight: 400;
    line-height: 150%;
    color: #ffffff;
  }

  .risk-content {
    text-align: justify;
    text-justify: inter-ideograph;
  }
</style>
